import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';

export const DIRECTOR_NAV_ITEMS = [
  { title: 'Dashboard', path: '/director/dashboard', icon: DashboardIcon },
  // { title: 'Reportes',  path: '/director/reportes',  icon: AssessmentIcon },
];

export const DIRECTOR_BOTTOM_NAV_ITEMS = [
  // { title: 'Configuración', path: '/director/config',    icon: SettingsIcon },
];
